import { useNavigate } from 'react-router-dom'
import { createContext, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useFirebase, useFirestore, useFirestoreConnect } from "react-redux-firebase";
import { getFunctions, httpsCallable } from "firebase/functions";
import { collectionToArray } from '@/utils/collectionToArray'
import Button from '@/components/Button'

const AuthContext = createContext(null);

const AuthProvider = ({ children }) => {
  const firebase = useFirebase();
  const firestore = useFirestore();
  const [isLoading, setIsLoading] = useState(false);
  const [authErrors, setAuthErrors] = useState(null);
  const [lastUpdated, setLastUpdated] = useState(new Date());
  const functions = getFunctions();
  const functionLastSeen = httpsCallable(functions, 'lastSeen');
  const functionSetUsername = httpsCallable(functions, 'setUsername');

  const auth = useSelector(state => state.firebase.auth);
  const userRef = firestore.collection("users").doc(auth.uid);
  const notifications = useSelector((state) => state.firestore.data.notifications);
  const accounts = useSelector((state) => state.firestore.data.accounts);
  const user = useSelector((state) => state.firestore.data.user);
  const userDuels = useSelector((state) => state.firestore.data.userduels);
  const joinedDuels = useSelector((state) => state.firestore.data.joinedduels);
  const userOrders = useSelector((state) => state.firestore.data.userorders);
  const chatHistory = useSelector((state) => state.firestore.data.messageHistory);
  const chats = useSelector((state) => state.firestore.data.messages);
  const exchangeRate = useSelector((state) => state.firestore.data.exchangeRate)
  const fiatRate = useSelector((state) => state.firestore.data.fiatRate)
  const races = useSelector((state) => state.firestore.data.races)
  const stats = useSelector((state) => state.firestore.data.stats)
  const userAccountsSelector = useSelector((state) => state.firestore.data.userAccounts)

  const [userBalance, setUserBalance] = useState(null);
  const [userAccounts, setUserAccounts] = useState([])
  const [userPrimaryAccount, setUserPrimaryAccount] = useState(null);
  const [racesData, setRacesData] = useState([])
  const [ordersData, setOrdersData] = useState([])
  const [statsData, setStatsData] = useState([])
  const [ignoreAcceptDuelWarning, setIgnoreAcceptDuelWarning] = useState(localStorage.getItem('accept_duel_warning'))
  useEffect(() => {
    setUserBalance(user?.balance)
  }, [user])

  useEffect(() => {
    const racesDataArray = collectionToArray(races)
    setRacesData(racesDataArray)
  }, [races])

  useEffect(() => {
    const ordersArray = collectionToArray(userOrders)
    setOrdersData(ordersArray)
  }, [userOrders])

  useEffect(() => {
    const userAccountsDataArray = collectionToArray(userAccountsSelector)
    setUserAccounts(userAccountsDataArray)
    setUserPrimaryAccount(userAccountsDataArray.find(account => account.primary))
  }, [userAccountsSelector])

  //   const { data } = useFirestoreListener(`users/${auth.uid}/accounts`)
  // console.log(data)
  // const userAccountsListener = () => useFirestoreListener(`users/${auth.uid}/accounts`)

  // useEffect(() => {
  //   // firestore.collection(`users/${auth.uid}/accounts`).onSnapshot(snapshot => {
  //   //   console.log(snapshot)
  //   // })
  //   // firestore.collection(`users/${auth.uid}/accounts`).onSnapshot((snapshot) => {
  //   //   snapshot.docChanges().forEach((change) => {
  //   //     if (change.type === "added") {
  //   //       console.log("New city: ", change.doc.data());
  //   //     }
  //   //     if (change.type === "modified") {
  //   //       console.log("Modified city: ", change.doc.data());
  //   //     }
  //   //     if (change.type === "removed") {
  //   //       console.log("Removed city: ", change.doc.data());
  //   //     }
  //   //   });
  //   // if (auth.uid) {
  //   //   const {data} = useFirestoreListener(`users/${auth.uid}/accounts`)
  //   //   console.log(data)
  //   // }
  //   if (auth.uid) {
  //     userAccountsListener()
  //   }
  // }, [auth])
  // if (auth.uid) {
  //   const { data } = useFirestoreListener(`users/${auth.uid}/accounts`)
  //   console.log(data)
  // }

  const googleLogin = () => {
    return firebase
      .login({
        provider: "google",
        type: "popup",
      })
  }

  const login = (email, password) => {
    return firebase.login({
      email,
      password
    })
  }

  firebase.auth().onAuthStateChanged(async (authUser) => {
    if (authUser) {
      // User logged in already or has just logged in.
      let currentDate = new Date();
      currentDate.setMinutes(currentDate.getMinutes() - 1);
      if (lastUpdated.getTime() < currentDate.getTime()) {
        setLastUpdated(new Date());
        functionLastSeen(auth.uid);
      }
    } else {
      // User not logged in or has just logged out.

    }
  });

  const resendVerificationEmail = (email) => {
    return firebase.auth().currentUser.sendEmailVerification();
  }

  const logout = async () => {
    await firebase.logout()
  }

  const lookupUser = async (uid) => {
    const lookupRef = firestore.collection('users').doc(uid);
    const doc = await lookupRef.get();
    return doc.data();
  }

  const setUsername = (username) => {
    return functionSetUsername({ username });
  }

  const updateIgnoreAcceptDuelWarning = (val) => {
    localStorage.setItem('accept_duel_warning', val)
    setIgnoreAcceptDuelWarning(val)
  }

  useFirestoreConnect({
    collection: 'settings',
    doc: 'maintenance',
    storeAs: "maintenance",
  });

  let maintenanceMode = useSelector((state) => state.firestore.data.maintenance);

  if (maintenanceMode?.value) {
    return (
      <div className="min-h-screen fixed px-4 inset-0 bg-gradient-to-br from-gray-700 to-gray-900 flex flex-col items-center justify-center">
        <div className="text-center max-w-md">
          <h1 className="font-bold text-5xl text-white tracking-tight">Duels.gg</h1>
          <p className="text-white/75 text-xl font-semibold mt-4">We are currently in maintenance mode. Please come back shortly.</p>
          <a href="https://discord.gg/duel-arena" target="__blank" className="bg-gradient-to-b via-yellow-500 from-yellow-500 to-yellow-600 text-gray-900 tracking-tight overflow-hidden relative block rounded mt-4 transition duration-300 text-sm text-white font-medium shadow-lg py-2.5 w-full">
            <span>Join Discord</span>
          </a>
        </div>
      </div>
    )
  }

  return (<AuthContext.Provider value={{
    auth,
    user,
    login,
    googleLogin,
    logout,
    resendVerificationEmail,
    lookupUser,
    setUsername,
    notifications,
    accounts,
    userPrimaryAccount,
    chats,
    stats,
    chatHistory,
    userRef,
    userBalance,
    userDuels,
    joinedDuels,
    userOrders,
    ordersData,
    authErrors,
    isLoading,
    exchangeRate,
    fiatRate,
    racesData,
    userAccounts,
    ignoreAcceptDuelWarning,
    updateIgnoreAcceptDuelWarning
  }}>
    {children}
  </AuthContext.Provider>)
}

export { AuthProvider, AuthContext }